import Default from "./Default";

/**
 * @typedef {import("@prismicio/client").Content.EmbedSlice} EmbedSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<EmbedSlice>} EmbedProps
 * @param {EmbedProps}
 */
const Embed = ({ slice: { variation, primary } }) => {
	switch (variation) {
		case "default":
			return <Default primary={primary} />;
	}
};

export default Embed;
